import { Header } from '@/components/Layout/Header/Header';
import { Calendar } from '@/components/Common/Calendar/Calendar';
import dateIcon from '@/assets/icons/date.svg';
import { FinanceDashboard } from '@/components/Views/Finance/FinanceDashboard';
import { FinanceList } from '@/components/Views/Finance/FinanceDashboard/FinanceList';
import { Tabs } from '@/components/Ui';
import { useFinance } from '@/components/Views/Finance/useFinance';
import StatCard from '@/components/Views/StatCard/StatCard';
const Finances = () => {
  const { activeTab, setActiveTab } = useFinance();
  return (
    <div className="flex flex-col max-h-screen">
      <Header userName="Mas Aly" role="Admin">
        <Calendar
          type="range"
          name="range"
          label="Filtrer par periode"
          dateIcon={dateIcon}
        />
      </Header>
      <div className="flex justify-between">
        <Tabs
          activeIndex={activeTab}
          setActiveIndex={setActiveTab}
          tabs={[
            { id: 1, title: 'Finances globales' },
            // { id: 2, title: 'Details des transactions' },
          ]}
        />
        {activeTab === 1 && (
          <StatCard
            title="Montant"
            cardStyle="w-[226px] border border-primary bg-primary/5"
            value={980}
          />
        )}
      </div>
      {activeTab === 0 && <FinanceDashboard />}
      {activeTab === 1 && <FinanceList />}
    </div>
  );
};

export default Finances;
